import { render } from "./ProductDetail.vue?vue&type=template&id=1397f33e&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=1397f33e&scoped=true&lang=css"
import "./ProductDetail.vue?vue&type=style&index=1&id=1397f33e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1397f33e"]])

export default __exports__